/** Landing page after Microsoft sign-in (/auth/callback): swap the code for tokens, then open DocVault. */
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { finishMicrosoftSignIn } from "../auth/microsoft";
import dvEndorsed from "../assets/brand/dv-endorsed.svg";

export function AuthCallbackPage() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState<string | null>(null);
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return; // React StrictMode runs effects twice in development; a code works once
    ran.current = true;
    (async () => {
      try {
        const r = await finishMicrosoftSignIn(window.location.search);
        if ("retrying" in r) return; // going back through Microsoft once to finish linking accounts
        if (!r.ok) return setErr(r.message);
        const loadErr = await refresh();
        if (loadErr) return setErr(`Microsoft signed you in, but DocVault couldn't open your account: ${loadErr}`);
        nav("/", { replace: true });
      } catch (e) {
        setErr((e as Error).message || "Microsoft sign-in didn't complete.");
      }
    })();
  }, [refresh, nav]);
  return (
    <div className="boot">
      <div style={{ textAlign: "center", maxWidth: 420 }}>
        <img src={dvEndorsed} alt="DocVault from ITAssurance" />
        {err ? (
          <>
            <p role="alert"><b style={{ color: "var(--ink)" }}>{err}</b></p>
            <Link className="btn btn-accent" to="/login" replace>Back to sign in</Link>
          </>
        ) : <div className="spin">Signing you in with Microsoft…</div>}
      </div>
    </div>
  );
}
